<template>
  <v-dialog v-model="dialogEditShow" max-width="400px">
    <v-card class="pa-6 test-editor">
      <h4 class="mb-6">Редактирование рангов ответов</h4>
      <v-btn class="button-close ma-4" icon @click="dialogEditShow=false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <div class="items-list-wrapper">
      <transition-group class="items-list w-100" name="list-complete" tag="div">
        <div v-if="!localRankPointMapping || !localRankPointMapping.length" class="mb-4" :key="-1">Добавьте ранги</div>
        <v-row v-for="(item, index) in localRankPointMapping" :key="index+100" align="center" >
          <v-col cols="4" class="text-h6">
            {{ index + 1 }}.
          </v-col>
          <v-col cols="6">
            <v-select v-model="localRankPointMapping[index]" :items="possiblePoints" label="Балл" dense outlined hide-details></v-select>
          </v-col>
          <v-col cols="2">
            <v-btn icon color="error" @click="removeMapping(index)" v-if="index === localRankPointMapping.length-1">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <div class="row row-complete-item" :key="-2">
          <v-btn class="add-button" fab dark small color="primary" @click="addMapping()">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </transition-group>
      </div>
      <div class="d-flex justify-end mt-7">
        <v-btn class="mr-3 _w-100" @click="dialogEditShow=false"> Закрыть </v-btn>
        <v-btn class="mr-3 _w-100" color="primary" @click="saveMapping" :loading="saving"> Сохранить </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: Boolean,
    instrument: Object,
  },
  data() {
    return {
      localRankPointMapping: [],
      saving: false,
    };
  },
  watch: {
    async dialogEditShow(newVal) {
      if (newVal) {
        this.loadLocalMapping();
      }
    }
  },
  computed: {
    dialogEditShow: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    nValue() {
      return Object.keys(this.localRankPointMapping).length;
    },
    possiblePoints() {
      return Array.from({ length: this.nValue }, (_, i) => String(i));
    },
  },
  methods: {
    ...mapActions({
      saveInstrument: 'testEditor/saveInstrument',
    }),
    loadLocalMapping() {
      this.localRankPointMapping = Object.values(this.instrument.rank_point_mapping);
    },
    addMapping() {
      // Добавляем новый элемент. По умолчанию ставим 1.
      // `possiblePoints` всегда будет иметь "1", если N >= 1.
      this.localRankPointMapping.push(this.nValue);
    },
    removeMapping(index) {
      if (this.localRankPointMapping.length) {
        this.localRankPointMapping.splice(index, 1);
      }
    },
    async saveMapping() {
      this.saving = true;
      const newMapping = {};
      this.localRankPointMapping.forEach((value, index) => {
        newMapping[String(index + 1)] = value;
      });
      this.instrument.rank_point_mapping = newMapping;
      await this.saveInstrument(this.instrument);
      this.dialogEditShow = false;
      this.saving = false;
    },
  },
};
</script>

<style>

</style>
